import { axios } from './common';
import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import {
  downloadFile,
  showFileDownloadFailedNotification,
  showFileDownloadSucessNotification,
  showFileDownloadingNotification
} from '../../pages/cm/utils/common';

import { getLocalTimezone } from '../../util/timezone';

import { uniqueId } from '../../util/lodashlike';
export const fetchAutomationList = async () => {
  const url = `${CM_BASE_URL}/automation-settings`;
  const res = await axios.get(url);

  if (res.status !== 200) {
    throw new Error(res.data.error ?? 'Failed to fetch the automation list');
  }

  return res.data;
};

export const addAutomation = async ({ automationData }) => {
  const url = `${CM_BASE_URL}/automation-settings`;
  return axios.post(url, automationData).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.error ?? 'Automation could not be added');
    }

    return res.data;
  });
};

export const updateAutomation = async ({ id, configData }) => {
  const url = `${CM_BASE_URL}/automation-settings/${id}`;

  return axios.put(url, configData).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.error ?? 'Failed to update the automation');
    }

    return res.data;
  });
};

export const updateAutomationName = async ({ id, name }) => {
  const url = `${CM_BASE_URL}/automation-settings/${id}/name`;
  const params = { name };

  return axios.put(url, params).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.error ?? 'Failed to update the automation name');
    }

    return res.data;
  });
};

export const updateAutomationEnabledFlag = async ({ id, enabled }) => {
  const url = `${CM_BASE_URL}/automation-settings/${id}/automation-flag`;
  const params = { enabled };

  return axios.put(url, params).then((res) => {
    if (res.status !== 200) {
      throw new Error(
        res.data.error ?? 'Failed to update the automation enabled flag'
      );
    }

    return res.data;
  });
};

export const deleteAutomation = async ({ id }) => {
  const url = `${CM_BASE_URL}/automation-settings/${id}`;

  return axios.delete(url).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.error ?? 'Failed to delete the automation');
    }

    return res.data;
  });
};

export const setAutomationPriority = async (payload) => {
  const url = `${CM_BASE_URL}/automation-settings/setPriority`;
  return axios.put(url, payload).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.error ?? 'Failed to set priority');
    }

    return res.data;
  });
};

export const fetchAutomationCustomers = async ({ automationId }) => {
  const url = `${CM_BASE_URL}/automated-customers/${automationId}`;
  const res = await axios.get(url);

  if (res.status !== 200) {
    throw new Error(
      res.data.error ?? 'Failed to fetch the automation customers'
    );
  }

  return res.data;
};

export const saveAutomationCustomers = async ({
  automationId,
  customerIds,
  deleteCustomerIds
}) => {
  const url = `${CM_BASE_URL}/automated-customers/${automationId}`;
  const params = { customerIds, deleteCustomerIds };

  return axios.post(url, params).then((res) => {
    if (res.status !== 200) {
      throw new Error(
        res.data.error ?? 'Failed to update the automation customers'
      );
    }

    return res.data;
  });
};

export const downloadTemplate = (setLoading) => {
  const uuid = uniqueId();
  const fileName = 'Customer Bulk-Upload Template.csv';

  showFileDownloadingNotification({
    key: uuid,
    fileName
  });

  const url = `${CM_BASE_URL}/automation-settings/sampleTemplate`;
  axios
    .get(url, {
      responseType: 'blob',
      headers: { 'Time-Zone': getLocalTimezone() }
    })
    .then((res) => {
      if (res.status === 200) {
        showFileDownloadingNotification({ key: uuid, fileName });
        try {
          downloadFile(res.data, fileName);
          showFileDownloadSucessNotification({ key: uuid, fileName });
          setLoading(false);
        } catch (e) {
          showFileDownloadFailedNotification({ key: uuid, fileName });
          setLoading(false);
        }
      } else {
        showFileDownloadFailedNotification({ key: uuid, fileName });
        setLoading(false);
      }
    });
};
